import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";

const StackedColumnChart = ({ dataColors, datamonth }) => {
  const [series, setSeries] = useState([]);
  const stackedColumnChartColors = getChartColorsArray(dataColors);

  useEffect(() => {
    if (datamonth) {
      const groupedData = groupMonthlyData(datamonth);
      setSeries(groupedData);
    }
  }, [datamonth]);

  const groupMonthlyData = (data) => {
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const statusTypes = [
      { key: "HOTEL_ACCEPTED", label: "Hotel Accepted" },
      { key: "HOTEL_REFUSED", label: "Hotel Refused" },

      { key: "PENDING", label: "Pending" },
    ];

    const grouped = statusTypes.map((status) => ({
      name: status.label,
      data: Array(12).fill(0),
    }));

    Object.entries(data).forEach(([monthYear, reservations]) => {
      const [year, month] = monthYear.split("-");
      const monthIndex = parseInt(month) - 1; // Months are 0-indexed

      reservations.forEach((reservation) => {
        const statusIndex = statusTypes.findIndex((status) => status.key === reservation.status);
        if (statusIndex !== -1) {
          grouped[statusIndex].data[monthIndex] += 1;
        }
      });
    });

    return grouped;
  };

  const options = {
    chart: {
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: true },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "15%",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
    colors: stackedColumnChartColors,
    legend: { position: "bottom" },
    fill: { opacity: 1 },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height="359"
      className="apex-charts"
    />
  );
};

StackedColumnChart.propTypes = {
  dataColors: PropTypes.string.isRequired,
  datamonth: PropTypes.object.isRequired,
};

export default StackedColumnChart;